import { render, staticRenderFns } from "./CriticsModal.vue?vue&type=template&id=b886040a&"
import script from "./CriticsModal.vue?vue&type=script&lang=js&"
export * from "./CriticsModal.vue?vue&type=script&lang=js&"
import style0 from "./CriticsModal.vue?vue&type=style&index=0&id=b886040a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports